import { Storage } from './Storage';

const AFTER_LOGIN_GOTO_KEY = 'afterLoginGotoKey';

class LoginHelper {
  static setLoginSuccessRoute(routeName, pathParams = {}, queryParams = {}) {
    Storage.set(AFTER_LOGIN_GOTO_KEY, {
      routeName,
      queryParams,
      pathParams,
    });
  }

  static getLoginSuccessRoute() {
    return Storage.get(AFTER_LOGIN_GOTO_KEY) || {};
  }

  static clearLoginSuccessRoute() {
    Storage.remove(AFTER_LOGIN_GOTO_KEY);
  }
}

export { LoginHelper };



// WEBPACK FOOTER //
// ./src/helpers/LoginHelper.js